import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=407c78ff&scoped=true"
import script from "./NewMessage.vue?vue&type=script&lang=js"
export * from "./NewMessage.vue?vue&type=script&lang=js"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=407c78ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c78ff",
  null
  
)

export default component.exports